import * as React from "react";
import { forwardRef } from "react";
const SvgHome = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10 1.4L1.6 8.1V18.4H7.4V12.1H12.6V18.4H18.4V8.1L10 1.4Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgHome);
export default ForwardRef;
